export const jobLocation = [
  {
    label: 'Hyderabad',
    value: 'Hyderabad',
  },
  {
    label: 'Noida',
    value: 'Noida',
    selected: false,
  },
  {
    label: 'Gurugram',
    value: 'Gurugram',
  },
];

export const hireMgrLocation = [
  {
    label: 'Hyderabad',
    value: 'Hyderabad',
  },
  {
    label: 'Noida',
    value: 'Noida',
    selected: false,
  },
  {
    label: 'Gurugram',
    value: 'Gurugram',
  },
];

export const timeZone = [
  {
    label: 'IST',
    value: 'IST',
  },
  {
    label: 'CST',
    value: 'CST',
    selected: false,
  },
  {
    label: 'PST',
    value: 'PST',
  },
];

export const priorityOptions = [
  {
    label: 'Critical',
    value: 'true',
  },
  {
    label: 'Standard',
    value: 'false',
  },
];

export const validFileTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const HiringManagerLevels = [1, 2, 3, 4, 5];

export const editFields = [
  'lineOfBusiness',
  'hiringManager',
  'vendors',
  'dntLeader',
  'hirManEmail',
  'priorityOptions',
];

export const panelMemberOne = 'panelMemberOne';
export const panelMemberTwo = 'panelMemberTwo';
